// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
import axios from "axios";
import { LoginConfig } from "./login-config";

const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");

export const createApiClient = () => {
    return axios.create({
        baseURL: LoginConfig.apiBaseURL,
        withCredentials: true
    });
};